import React, { useEffect, useState } from "react";
import useCountdown from "@/hooks/useCountdown";
import { EVENT_DATETIME_ISO, TICKET_URL, EVENT } from "@/data/content";
import { trackTicketClick } from "@/lib/analytics";

/**
 * Sticky CTA: muncul selepas pengguna scroll melepasi hero, dan
 * disembunyikan sepenuhnya (visibility + pointer-events) apabila
 * seksyen tiket ATAU footer berada pada skrin.
 *
 * Pengiraan dibuat secara geometri di dalam handler scroll (dikawal
 * requestAnimationFrame) supaya keadaan sentiasa tepat serta-merta,
 * tanpa bergantung pada callback tak segerak atau polling.
 */
export default function StickyCta() {
  const [show, setShow] = useState(false);
  const { days } = useCountdown(EVENT_DATETIME_ISO);

  useEffect(() => {
    let raf = 0;

    const onScreen = (el) => {
      if (!el) return false;
      const r = el.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    };

    const compute = () => {
      const vh = window.innerHeight;
      const pastHero = window.scrollY > vh * 0.9;
      const blocked =
        onScreen(document.getElementById("tiket")) ||
        onScreen(document.querySelector(".footer"));
      setShow(pastHero && !blocked);
    };

    const schedule = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        compute();
      });
    };

    compute();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    // Seksyen bawah dimuat secara lazy: kira semula beberapa kali awal
    // supaya #tiket dan .footer dikesan sebaik ia muncul.
    const t1 = setTimeout(compute, 800);
    const t2 = setTimeout(compute, 2000);
    const t3 = setTimeout(compute, 4000);

    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className={`stickycta ${show ? "is-visible" : ""}`}
      aria-hidden={!show}
      data-testid="sticky-cta"
    >
      <div className="stickycta__text">
        <strong>{EVENT.title}</strong>
        <span>
          {days} hari lagi &middot; {EVENT.venue}
        </span>
      </div>
      <a
        className="btn btn--gold btn--sm"
        href={TICKET_URL}
        target="_blank"
        rel="noreferrer"
        onClick={() => trackTicketClick("sticky")}
        data-testid="sticky-cta-button"
      >
        BELI TIKET
      </a>
    </div>
  );
}
